import { z } from 'zod'

import {
  DiscountAudience,
  DiscountType,
  PaymentProvider,
} from '../constants/pricing'
import {
  MembershipReferralType,
  MembershipStatus,
} from '../constants/membership'
import {
  VenueBillingIntervalUnit,
  VenueBillingType,
} from '../constants/venueBilling'
import { dbEntitySchema } from './system'

export const membershipDiscountSchema = z.object({
  id: z.string(),
  promo: z.string().optional(),
  discount: z.string().optional(),
  promoCode: z.string().optional(),
  name: z.string().optional(),
  type: z.nativeEnum(DiscountAudience),
  amount: z.number().min(0),
  amountType: z.nativeEnum(DiscountType),
  applied: z.date().optional(),
})

export const membershipMemberReferralSchema = z.object({
  id: z.string().optional(),
  type: z.nativeEnum(MembershipReferralType).optional(),
})

export const membershipSchema = dbEntitySchema.extend({
  signUpCity: z.string().optional(),
  plan: z.string(),
  planName: z.string(),
  price: z.number(),
  user: z.string(),
  affiliate: z.string().optional(),
  trackingId: z.string().optional(),
  userLevel: z.number(),
  paymentProfile: z.string(),
  status: z.nativeEnum(MembershipStatus),
  billingType: z.nativeEnum(VenueBillingType).optional(),
  billingInterval: z.number().optional(),
  billingIntervalUnit: z.nativeEnum(VenueBillingIntervalUnit).optional(),
  firstBillingDate: z.date().optional(),
  billingPeriodEndDate: z.date().optional(),
  cancelDate: z.date().optional(),
  referral: membershipMemberReferralSchema.optional(),
  discounts: z.array(membershipDiscountSchema).optional(),
  providerType: z.nativeEnum(PaymentProvider),
  externalId: z.string().optional(),
  externalPlanId: z.string().optional(),
  statusDescription: z.string().optional(),
  active: z.boolean().optional(),
})

export const membershipListQuerySchema = z.object({
  status: z
    .union([
      z.nativeEnum(MembershipStatus),
      z.array(z.nativeEnum(MembershipStatus)),
    ])
    .optional(),
  affiliateId: z.string().optional(),
  trackingId: z.string().optional(),
})

export const membershipPlanSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  shortDescription: z.string(),
  imageUrl: z.string(),
  userLevel: z.number(),
  billingPrice: z.number(),
  billingType: z.nativeEnum(VenueBillingType),
  billingInterval: z.number(),
  billingIntervalUnit: z.nativeEnum(VenueBillingIntervalUnit),
  billingIntervalPrice: z.number(),
  providerType: z.nativeEnum(PaymentProvider),
  externalPlanId: z.string(),
  terms: z.array(z.string()),
})

export const membershipCreateArgsSchema = z.object({
  userId: z.string(),
  planId: z.string(),
  paymentProfileId: z.string(),
  promoCode: z.string().optional(),
  affiliateId: z.string().optional(),
  trackingId: z.string().optional(),
  freeTrial: z.boolean().optional(),
  price: z.number().optional(),
})

export const membershipPreviewArgsSchema = z.object({
  planId: z.string(),
  promoCode: z.string().optional(),
  userId: z.string().optional().nullable(),
  price: z.number().optional(),
})

export const membershipUpdatePaymentProfileArgsSchema = z.object({
  id: z.string(),
  paymentProfileId: z.string(),
})
